import { useEffect, useState } from "react";

const useCheckMobileScreen = () => {
  const [width, setWidth] = useState(
    document.getElementsByClassName("motion-configurator-app")[0]?.offsetWidth || window.innerWidth
  );
  const handleWindowSizeChange = () => {
    setWidth(document.getElementsByClassName("motion-configurator-app")[0]?.offsetWidth || window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    handleWindowSizeChange();
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return width <= 768;
};

export default useCheckMobileScreen;
